
export default (function onFirstRun() {
  let keys = []
  return function _onFirstRun(key, callback) {
    if (~keys.indexOf(key)) return
    const isCountThisAttempt = callback()
    if (isCountThisAttempt !== false) keys.push(key)
  }
}())
